import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

// import modules
import resumeData from './modules/resumeData'
import modalData from './modules/modalData'
import dataBO from './modules/dataBO'
import enginesData from './modules/enginesData'
import versionsData from './modules/versionsData'
import images360 from './modules/images360'
import panoram360 from './modules/panoram360'
import navbarState from './modules/navbarState'
import dealersLst from './modules/dealersLst'

Vue.use(Vuex)

const hyu = process.env.VUE_APP_HYU

// const modelsHeader = {
//     'Content-Type': 'application/json',
//     'AccessToken': process.env.VUE_APP_MODELSTOKEN,
// }

export default new Vuex.Store({
    state: {
        hyuSite: 'https://www.hyundai.pt/',
        windowResizeEventFired: false,
        carsLst: [],
        hasCars: false,
        carsInfo: [],
        localDate: 'pt-pt',
        footerHeight: 0,
    },
    getters:{
        getSortedCarsLstByPrice: state => {
            let res = state.carsLst.sort((prev, curr) => {
                let a = prev.price
                let b = curr.price
                return parseFloat(a) > parseFloat(b) ? 1 : -1
            })
            return res
        },
        getPipContent: state => (id, key) => {
            let res = state.carsInfo.find(el => el.id == id)
            if(key) return (res != undefined) ? res[key] : ''
            return (res != undefined) ? res : ''
        },
        getModelsSegments: state => {
            let segments = [];
            state.carsLst.forEach(el => {
                el.segments.forEach(item => {
                    if(!segments.some(seg => seg.id ===item.id )) segments.push(item)
                })
            });
            return (segments.length != 0) ? segments : false
        },
        getModelNameById: state => id => {
            return state.carsLst.find(el => el.id == id).model
        },
        getModelById: state => id => {
            return state.carsLst.find(el => el.id == id)
        },
    },
    mutations: {
        UPDATE_ROOT_STATE(state, payload){
            state = Object.assign(state, payload)
        },
        SET_MODEL_LST(state, payload){
            state.carsLst = payload
            state.hasCars = true
        },
        SET_WSR(state){
            state.windowResizeEventFired = true
        },
        SET_CATALOG(state, payload){
            let contain = state.catalogs.some(el => el == payload.id)
            if(!contain){ state.catalogs.push(payload) }
        },
        SET_CARSPODS_INFO(state, payload){
            state.carsInfo = payload
        }
    },
    actions: {
        fetchModelsLst({ commit }){
            // axios.get(hyu + process.env.VUE_APP_API_MODELS,{ headers: modelsHeader })
            axios.get(hyu + process.env.VUE_APP_API_MODELS)
            .then( res => commit('SET_MODEL_LST', res.data))
            .catch( err => console.log(err))
        },
        fetchCarrosPods({ commit }){
            // axios.get(hyu + process.env.VUE_APP_API_MODELS_BO_DATA,{ headers: modelsHeader })
            axios.get(hyu + process.env.VUE_APP_API_MODELS_BO_DATA)
            .then( res => commit('SET_CARSPODS_INFO', res.data))
            .catch( err => console.log(err))
        }
    },
    modules: {
        resumeData,
        modalData,
        dataBO,
        enginesData,
        versionsData,
        images360,
        panoram360,
        navbarState,
        dealersLst
    }
})
